<template>
  <div>
    <v-menu close-on-content-click>
      <template #activator="{ props }">
        <v-tooltip location="bottom">
          <template #activator="{ props: tooltip }">
            <div v-bind="props">
              <v-btn-icon
                icon="mdi-help-circle"
                v-bind="tooltip"
                :class="[{ 'px-5': $vuetify.display.sm }, { 'px-4': $vuetify.display.xs }]"
                data-testid="helpItem.menu-button"
              >
              </v-btn-icon>
            </div>
          </template>
          <span>Help</span>
        </v-tooltip>
      </template>
      <v-list density="compact" data-testid="helpItem.menu-list">
        <v-list-item data-testid="helpItem.guides-list-item" @click="onboarding_Dialog = true">
          <v-list-item-title>Guides</v-list-item-title>
        </v-list-item>
        <v-list-item @click="openContactPage()">
          <v-list-item-title>Contact Us</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <guides-dialog :model-value="onboarding_Dialog" @cancel="onboarding_Dialog = false" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import GuidesDialog from "../../../Onboarding/GuidesDialog.vue";

// function HelpItem() {}

const onboarding_Dialog = ref(false);

function openContactPage(): void {
  const url = "https://info.itemis.com/en/yakindu/lowcode/contact";
  window.open(url, "_blank");
}
</script>

<style scoped></style>
